import React from "react";
import { WEBAPP_URL } from "../../urls";

const PricingContent = [
  {
    packName: "Free Trial",
    packDetails: "Kickstart your Success",
    bgColor: "#FFF7EB",
    price: "0",
    durationNumber: "Test the Waters",
    facility: "first interview on us!",
    features: [
      "2 Free Interviews",
      "2 Free Insight Reports",
      "2 Free transcripts"
    ],
    animationDelay: "",
    activeClass: "",
  },
  {
    packName: "Starter",
    packDetails: "For serious job hunters!",
    bgColor: "#E2F2FD",
    price: "9.99",
    durationNumber: "Monthly",
    facility: "level up",
    features: [
      "10 Monthly Interviews",
      "Insight Reports",
      "Transcripts",
    ],
    animationDelay: "100",
    activeClass: "active most-popular",
  },
  {
    packName: "Pro",
    packDetails: "Master the Interview Game!",
    bgColor: "#FFEBEB",
    price: "19.99",
    durationNumber: "Monthly",
    facility: "Unleash your full potential",
    features: [
      "30 Interviews Every Month",
      "Everything in Starter Tier",
      "Exclusive access to new features!"
    ],
    animationDelay: "200",
    activeClass: "",
  },
];

const PricingMonthly = () => {
  return (
    <div className="row justify-content-center">
      {PricingContent.map((val, i) => (
        <div
          className="col-lg-4 col-sm-6"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-delay={val.animationDelay}
          key={i}
        >
          <div className={`pr-table-wrapper ${val.activeClass}`}>
            <div className="pack-name">{val.packName}</div>
            <div className="pack-details">{val.packDetails}</div>
            <div
              className="top-banner d-md-flex"
              style={{ background: val.bgColor }}
            >
              <div className="price">
                <sup>$</sup>
                {val.price}
              </div>
              <div>
                <span>{val.durationNumber}</span>
                <em>{val.facility}</em>
              </div>
            </div>
            {/* /.top-banner */}
            <ul className="pr-feature">
              {val.features.map((list, i) => (
                <li key={i}>{list}</li>
              ))}
            </ul>
            <a href={WEBAPP_URL} className="trial-button">
              Join Beta Now!
            </a>
            <div className="trial-text">Join Beta now to get this discounted price, cancel any time</div>
          </div>
          {/* /.pr-table-wrapper */}
        </div>
      ))}
    </div>
  );
};

export default PricingMonthly;
